import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Context } from "../../index";
import PageHeader from "../../components/header/pageheader/PageHeader";
import UniversalForm from "../../components/forms/UniversalForm";
import Modal from "../../components/forms/wrap/Modal";
import { useModal } from "../../components/hooks/useModal";
import { PlantList } from "../../features/plant-list/PlantList";
import "./PlantsPage.css";

const PlantsPageBase = observer(() => {
  const navigate = useNavigate();
  const { store, uploadStore } = useContext(Context);
  const modal = useModal(false);

  const [mode, setMode] = useState<"create" | "edit">("create");

  // --- Логика модалки ---
  const openForm = () => {
    setMode("create");
    store.setPlant({});
    modal.open();
  };

  const editForm = (plantId: number) => {
    const plant = store.plants.find((p) => p.id === plantId);
    if (plant) {
      store.setPlant(plant);
      setMode("edit");
      modal.open();
    }
  };

  const closeForm = () => {
    store.setPlant({});
    modal.close();
  };

  const createNewObject = (object: any) => {
    store.createPlant(object);
    closeForm();
  };

  const deletePlant = (plant_id: number) => {
    store.deletePlant(plant_id);
    closeForm();
  };

  const editPlant = async (plant: any) => {
    await store.editPlant(plant);
    closeForm();
  };

  const handlePlantClick = (plantId: number, companyId: number) => {
    const curPlant = store.plants.find((el) => el.id === plantId);
    if (!store.company?.id) {
      const curCompany = store.companies.find((el) => el.id === companyId);
      if (curCompany) store.setCompany(curCompany);
    }
    store.setPlant(curPlant);
    navigate("/inplants");
  };

  const handleImgUpload = async (file: File) => {
    const url = await uploadStore.uploadObjectPhoto(file, store.plant?.id);
    store.updatePlantPhotoUrl(url);
  };

  return (
    <>
      <div className="plant_container">
        <PageHeader
          title="Объекты"
          buttontext="Добавить объект"
          onCreate={openForm}
        />
        {/* Теперь PlantList сам читает store.company.id */}
        <PlantList onPlantClick={handlePlantClick} onEditPlant={editForm} />
      </div>

      <Modal isOpen={modal.isOpen} onClose={closeForm}>
        <UniversalForm
          mode={mode}
          handleCloseModal={closeForm}
          entityData={store.plant}
          fields={{
            company_id: {
              label: "Выберете организацию",
              type: "select",
              options: store.companies,
            },
            name: { label: "Наименование объекта", required: true },
            city: { label: "Город" },
            adress: { label: "Адрес" },
            description: { label: "Описание" },
          }}
          createEntity={createNewObject}
          editEntity={editPlant}
          deleteEntity={() => store.plant?.id && deletePlant(store.plant.id)}
          title="ДОБАВИТЬ ОБЪЕКТ"
          entity="объект"
          withPhotoUpload={true}
          onPhotoUpload={handleImgUpload}
        />
      </Modal>
    </>
  );
});

export default PlantsPageBase;
